import {type} from 'arktype';

export const FeeInfoEntry = type({
    label: 'string',
    value: 'string',
});
export type FeeInfoEntry = typeof FeeInfoEntry.infer;

export const FeeData = type({
    inputAmount: 'string',
    minimalAmount: 'string',
    minimalAmountExclusive: 'boolean',
    fee: 'string',
    commissionAbove: 'boolean',
    total: 'string',
    showFeeInfo: 'boolean',
    feeInfo: FeeInfoEntry.array(),
});
export type FeeData = typeof FeeData.infer;
